export default {
  dashboard: {
    sys: "Y System",
    title: "Dashboard",
    dim_selection: {
      today: "Today",
      yesterday: "Yesterday",
      recentWeek: "RecentWeek",
      recentMonth: "RecentMonth",
      halfYear: "HalfYear",
      recentYear: "RecentYear",
      currentMonth: "CurrentMonth",
      currentYear: "CurrentYear"
    },
    roomNights: "Room nights",
    yesterday: "Yesterday",
    lastYearSamePange: "Year-on-Year data",
    totalAmount: "Total amount",
    compareHotels: "Compare Hotels",
    collect: "Folder",
    showAll: "Show all",
    turnoverByAgency: "Revenue by agency",
    totalBookingAmount: "Total booking amount",
    agency: "Agency",
    bookingAmount: "Booking amount",
    totalRoomNights: "Total room nights"
  }
};
